document.addEventListener('DOMContentLoaded', () => {
  const spanish = document.documentElement.lang.toLowerCase().startsWith('es');
  const helper = document.querySelector('[data-tooth-helper]');
  if (!(helper instanceof HTMLElement)) return;

  const avatar = helper.querySelector('[data-tooth-avatar]');
  const panel = helper.querySelector('[data-tooth-panel]');
  const hint = helper.querySelector('[data-tooth-hint]');
  const close = helper.querySelector('[data-tooth-close]');
  const image = avatar?.querySelector('img');
  if (
    !(avatar instanceof HTMLButtonElement)
    || !(panel instanceof HTMLElement)
    || !(image instanceof HTMLImageElement)
  ) return;

  const sources = {
    idle: image.dataset.idleSrc,
    happy: image.dataset.happySrc,
    surprised: image.dataset.surprisedSrc,
  };
  const drag = {
    active: false,
    moved: false,
    pointerId: 0,
    x: 0,
    y: 0,
    startX: 0,
    startY: 0,
    minX: 0,
    maxX: 0,
    minY: 0,
    maxY: 0,
  };
  let position = { x: 0, y: 0 };
  let emotionTimer;

  const setEmotion = (emotion) => {
    helper.classList.remove('emotion-idle', 'emotion-happy', 'emotion-surprised');
    helper.classList.add(`emotion-${emotion}`);
    if (sources[emotion]) image.src = sources[emotion];
  };

  const setOpen = (open) => {
    panel.hidden = !open;
    if (hint instanceof HTMLElement) hint.hidden = open;
    helper.classList.toggle('is-open', open);
    avatar.setAttribute('aria-expanded', String(open));
    avatar.setAttribute(
      'aria-label',
      open
        ? (spanish ? 'Cerrar el asistente Foss' : 'Close Foss assistant')
        : (spanish ? 'Abrir el asistente Foss' : 'Open Foss assistant'),
    );
  };

  const toggleHelper = () => {
    if (drag.moved) return;
    const open = panel.hidden;
    setOpen(open);
    setEmotion(open ? 'happy' : 'surprised');
  };

  avatar.addEventListener('click', toggleHelper);
  avatar.addEventListener('pointerdown', (event) => {
    event.preventDefault();
    window.clearTimeout(emotionTimer);
    helper.classList.add('is-dragging');
    drag.active = true;
    drag.moved = false;
    drag.pointerId = event.pointerId;
    drag.x = event.clientX;
    drag.y = event.clientY;
    drag.startX = position.x;
    drag.startY = position.y;
    const rect = helper.getBoundingClientRect();
    const viewportMargin = 8;
    const baseLeft = rect.left - position.x;
    const baseTop = rect.top - position.y;
    drag.minX = viewportMargin - baseLeft;
    drag.maxX = window.innerWidth - viewportMargin - (baseLeft + rect.width);
    drag.minY = viewportMargin - baseTop;
    drag.maxY = window.innerHeight - viewportMargin - (baseTop + rect.height);
    avatar.setPointerCapture(event.pointerId);
  });
  avatar.addEventListener('pointermove', (event) => {
    if (!drag.active || drag.pointerId !== event.pointerId) return;
    event.preventDefault();
    const dx = event.clientX - drag.x;
    const dy = event.clientY - drag.y;
    if (!drag.moved && Math.hypot(dx, dy) > 6) {
      drag.moved = true;
    }
    if (!drag.moved) return;
    position = {
      x: Math.min(drag.maxX, Math.max(drag.minX, drag.startX + dx)),
      y: Math.min(drag.maxY, Math.max(drag.minY, drag.startY + dy)),
    };
    helper.style.transform = `translate3d(${position.x}px, ${position.y}px, 0)`;
  });

  const stopDrag = (event) => {
    if (!drag.active || drag.pointerId !== event.pointerId) return;
    drag.active = false;
    helper.classList.remove('is-dragging');
    if (avatar.hasPointerCapture(event.pointerId)) {
      avatar.releasePointerCapture(event.pointerId);
    }
    if (drag.moved) {
      window.setTimeout(() => {
        drag.moved = false;
      }, 0);
      emotionTimer = window.setTimeout(() => setEmotion('idle'), 520);
    }
  };

  avatar.addEventListener('pointerup', stopDrag);
  avatar.addEventListener('pointercancel', stopDrag);
  avatar.addEventListener('lostpointercapture', stopDrag);
  close?.addEventListener('click', () => {
    setOpen(false);
    avatar.focus();
  });

  helper.querySelector('[data-tooth-focus-email]')?.addEventListener('click', (event) => {
    const email = document.getElementById('PasswordEmail');
    if (!(email instanceof HTMLInputElement)) return;
    event.preventDefault();
    setOpen(false);
    email.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => email.focus(), 350);
  });
  helper.querySelector('[data-tooth-owner-access]')?.addEventListener('click', (event) => {
    const ownerAccess = document.getElementById('StoreOwnerAccess');
    if (!(ownerAccess instanceof HTMLDetailsElement)) return;
    event.preventDefault();
    setOpen(false);
    ownerAccess.open = true;
    ownerAccess.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => ownerAccess.querySelector('input')?.focus(), 350);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      setOpen(false);
      avatar.focus();
    }
  });
});
